import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SectionContainer } from '../../shared/sectionable/styles';

const Container = styled(SectionContainer)`
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.theme.isMobile ? 'flex-start' : 'flex-end')};
  margin: 24px 0 0;
  z-index: 1;
`;

const GenDate = styled.span`
  font: ${props => props.theme.fontWeightHeavy} 14px/100% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
  text-transform: uppercase;
`;

export default function Meta({ fund }) {
  const { updatedAt } = fund;
  const timestamp = moment(updatedAt);
  let date;
  if (updatedAt.length && timestamp.isValid()) {
    date = timestamp.format('Do MMM, YY');
  }

  if (!date) {
    return null;
  }

  return (
    <Container>
      <GenDate>{`updated ${date}`}</GenDate>
    </Container>
  );
}

Meta.propTypes = {
  fund: PropTypes.shape({
    updatedAt: PropTypes.string.isRequired,
  }).isRequired,
};
